/* eslint-disable no-unused-vars */
$(document).ready(function () {
	/*Filter jquery code*/
	$(document).on('click', '.selectedFilterVal > ul > li > span', function () {
		const dataCount = $(this).attr('data-count-theme');
		let dataType = $(this).attr('data-type');

		const dataCounttemp = $(this).attr('data-count-theme');
		$('.by-' + dataType + ' ul  a[id="' + dataCounttemp + '"]').parent().show();
		$(this).parent().remove();

		if (dataType == "category") {
			dataType = "subcategory";
			$('.' + dataType).each(function () {
				const dataCounttemp = $(this).attr('data-count-theme');
				$(this).parent().remove();
			});
			$('.by-subcategory').find('ul li').remove();
			$('.by-subcategory').hide();

		}

		if (dataType == "category" || dataType == "subcategory") {
			dataType = "subsubcategory";
			$('.' + dataType).each(function () {
				const dataCounttemp = $(this).attr('data-count-theme');
				$(this).parent().remove();
			});
			$('.by-subsubcategory').find('ul li').remove();
			$('.by-subsubcategory').hide();
		}

		check();
	});

	//Clear all selected filter
	$('.clear-all-filter').click(function () {
		$('.selectedFilterVal > ul > li').remove();
		$('.refine-result-info ul > li').show();
		$('.related-source').show();
		$('.refine-result-info').show();
		check();
	});

	//category show hide
	$('.by-Category ul li a').click(function () {
		$('.by-Category').hide();
		parCheck();
	});

	$(document).on('click', 'span[data-type="Category"]', function () {
		$('.by-Category').show();
	});

	//Region show hide
	$('.by-Region ul li a').click(function () {
		const numItem = $('.by-Region ul li:visible').length;
		numItem == 0 ? $('.by-Region').hide() : $('.by-Region').show();
		parCheck();
	});

	$(document).on('click', 'span[data-type="Region"]', function () {
		$('.by-Region').show();
	});

	//year show hide
	$('.by-Year ul li a').click(function () {
		const numItem = $('.by-Year ul li:visible').length;
		numItem == 0 ? $('.by-Year').hide() : $('.by-Year').show();
		parCheck();
	});

	$(document).on('click', 'span[data-type="Year"]', function () {
		$('.by-Year').show();
	});

	function check() {
		const numItem = $('.selectedFilterVal ul li').length;
		numItem == 0 ? $('.selection-area').hide() : $('.selection-area').show();
	}
	function parCheck() {
		$('.refine-result-info').is(":visible") ? $('.related-source').show() : $('.related-source').hide();
	}
});